import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { QuizRoutingModule } from './quiz-routing.module';
import { QuizComponent } from './quiz.component';
import {FormsModule} from '@angular/forms';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { CustomFlexLayoutModule } from 'src/app/flex-layout/custom-flex-layout.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    QuizComponent,
    
  ],
  imports: [
    CommonModule,
    QuizRoutingModule,
    MatCheckboxModule,
    FormsModule,
    MatMenuModule ,
    MatIconModule,
    CustomFlexLayoutModule,
    MatButtonModule 
  ],
  exports:[
    QuizComponent,

],
})
export class QuizModule { }
